import {getCurrentUser, UserModel} from "../../store/reducers/user/user.reducer";
import SiteBreadCrumb from "../../components/page-breadcrumb/page-breadcrumb.component";
import Typography from "@mui/material/Typography";
import React, {useEffect, useState} from "react";
import {PostModel} from "../../models/post.model";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import sendApiRequest, {NetworkMethods} from "../../lib/Network";
import toast from "react-hot-toast";
import {ApiResponseModel} from "../../models/apiresponse.model";
import ActionButton from "../../components/button/button.component";
import AdvancedTable from "../../components/tables/advanced_table.component";
import DeleteMenu from "../../components/menu/delete-menu.component";

export default function PostPage() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [posts, setPosts] = useState<PostModel[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pages, setPages] = useState<number>(1);
    const [open, setOpen] = useState<boolean>(false);
    const [deletingId, setDeletingId] = useState<string>("");

    const currentUser = useSelector(getCurrentUser);

    useEffect(() => {
        getPosts();

        return () => {};
    }, [])

    const getPosts = async () => {
        try {
            setIsLoading(true);

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `post?page=${page}&limit=10`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a lekérdezése közben! (${response?.error ?? "Nincs bővebb információ!"})`)
                return;
            }

            let postResponse: ApiResponseModel = response.data;

            setPages(postResponse.data.pages ?? 1);
            setPosts(postResponse.data.data);
            setIsLoading(false);
        } catch (error: any) {
            toast.error(`Hiba a lekérdezése közben! (${error?.message ?? "Nincs bővebb információ!"})`)
        }
    }
    const navigateToCreate = () => navigate("/posztok/letrehozas");
    const handlePageChange = async (page: number) => {
        try {
            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.GET,
                endpoint: `post?page=${page}&limit=10`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a lekérdezése közben! (${response?.error ?? "Nincs bővebb információ!"})`)
                return;
            }

            let postResponse: ApiResponseModel = response.data;

            setPages(postResponse.data.pages ?? 1);
            setPosts(postResponse.data.data);
            setIsLoading(false);
            setPage(page);
        } catch (error: any) {
            toast.error(`Hiba a törlés közben! (${error.message ?? "Nincs bővebb információ!"})`)
        }
    };
    const navigateToUpdate = (id: string) => navigate(`/posztok/szerkesztes/${id}`);
    const handleDelete = async () => {
        try {
            if (deletingId == "") return;

            const response = await sendApiRequest({
                headers: {
                    "x-public-key": process.env.REACT_APP_PUBLIC_REQUEST_KEY,
                    'Authorization': 'Bearer ' + currentUser.token
                },
                method: NetworkMethods.DELETE,
                endpoint: `post/delete/${deletingId}`,
            });

            if (!response.isSuccess) {
                toast.error(`Hiba a törlés közben! (${response?.error ?? "Nincs bővebb információ!"})`);
                return;
            }

            toast.success(`Sikeres törlés!`);
        } catch (error: any) {
            toast.error(`Hiba a törlés közben! (${error?.message ?? "Nincs bővebb információ!"})`);
        }
    }

    if (isLoading) {
        return <div>Betöltés...</div>
    }

    return (
      <div>
        <SiteBreadCrumb
          sites={[
            {
              name: "Főoldal",
              url: "/",
            },
            {
              name: "Posztok",
              url: "/posztok",
            },
          ]}
        />
        <Typography variant="h3">Bejegyzés varázsló</Typography>
        <br />
        <ActionButton
          title="Új bejegyzés létrehozása"
          type={"ADD"}
          action={navigateToCreate}
        />
        <br />
        <br />
        <Typography variant="h3">Elérhető bejegyzések</Typography>
        <br />
        <AdvancedTable
          columns={["ID", "Bejegyzés címe"]}
          rows={posts.map((post) => ({
            id: post.id,
            title: post.title,
          }))}
          properties={{
            page: page,
            pages: pages,
            rowsPerPage: 10,
            totalRows: pages * 10,
            disableSee: false,
            disableEdit: true,
            disableDelete: false,
          }}
          rowActions={{
            deleteAction: (row: any) => {
              setDeletingId(row.id);
              setOpen(true);
            },
            editAction: () => {},
            seeAction: (row: any) => navigateToUpdate(row.id),
          }}
          pageChange={handlePageChange}
        />

        <DeleteMenu
          open={open}
          handleClose={() => setOpen(!open)}
          handleDelete={handleDelete}
        />
      </div>
    );
}